module.exports = __webpack_public_path__ + "img/shape.0754de56.png";